export const vocabularyCs = {
    'probihajicichAnket': [
        'probíhajících anket',
        'probíhající anketa',
        'probíhající ankety',
    ],
    'letosUkoncenychAnket': [
        'letos ukončených anket',
        'letos ukončená anketa',
        'letos ukončené ankety',
    ],
    'anketCelkem': [
        'anket celkem',
        'anketa celkem',
        'ankety celkem',
    ],
    'respondentu': [
        'respondentů',
        'respondent',
        'respondenti',
    ],
};
